export { act, climbing, notSignedIn, Refused, read, upload, withoutTheVerb } from "./api.ts";

export async function leave(): Promise<void> {
  await fetch("/leave", { method: "POST", credentials: "same-origin" });
}
export {
  addADevice,
  addAPasskey,
  beginRegistering,
  makeADevice,
  passkeysWork,
  type Registering,
  registerWith,
  type SignedIn,
  signInWithAPasskey,
} from "./passkey.ts";
